import { PaymentPlan, PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useRootStore } from 'stores/RootStore'

export const FREE_PLAN: PaymentPlan = {
  id: undefined,
  name: 'Basic',
  key: PaymentPlanKey.Free,
  price: {
    month: {
      price_id: '',
      unit_amount: 0,
    },
    year: {
      price_id: '',
      unit_amount: 0,
    },
  },
  member_minimum: 1,
  member_limit: 3,
  doc_limit: undefined,
  base_price_meta: {},
}

export const ENTERPRISE_PLAN: PaymentPlan = {
  id: undefined,
  name: 'Enterprise',
  key: PaymentPlanKey.Enterprise,
  price: {
    month: {
      price_id: '',
      unit_amount: 0,
    },
    year: {
      price_id: '',
      unit_amount: 0,
    },
  },
  member_minimum: 31,
  member_limit: Infinity,
  doc_limit: undefined,
  base_price_meta: {},
}

export const EARLY_ADOPTER_PLAN: PaymentPlan = {
  id: undefined,
  name: 'Early Adopter',
  key: PaymentPlanKey.EarlyAdopter,
  price: {
    month: {
      price_id: '',
      unit_amount: 0,
    },
    year: {
      price_id: '',
      unit_amount: 0,
    },
  },
  member_minimum: undefined,
  member_limit: undefined,
  doc_limit: undefined,
  base_price_meta: {},
}

export const BUSINESS_PLAN: PaymentPlan = {
  id: undefined,
  name: 'Business',
  key: PaymentPlanKey.BlazeBusiness,
  price: {
    month: {
      price_id: '',
      unit_amount: 0,
    },
    year: {
      price_id: '',
      unit_amount: 0,
    },
  },
  member_minimum: 31,
  member_limit: Infinity,
  doc_limit: undefined,
  base_price_meta: {},
}

/**
 * Returns payment plans from TierUsageStore.
 * The data is fetched once when the app loads via TieredUsageListener.
 */
export const usePaymentPlans = () => {
  const tierUsageStore = useRootStore().tierUsageStore

  // The store already includes EARLY_ADOPTER_PLAN, so we derive legacyPaymentPlans from it
  const paymentPlans = tierUsageStore.paymentPlans
  const legacyPaymentPlans = paymentPlans.length > 0 ? [EARLY_ADOPTER_PLAN, ...paymentPlans] : []

  return {
    fetched: tierUsageStore.initialized,
    paymentPlans,
    legacyPaymentPlans,
  }
}
